export const MIN_QUANTITY_TRAINING_GROUP = 1;
export const MAX_QUANTITY_TRAINING_GROUP = 100;
export const MIN_QUANTITY_TIMES_APPLIES = 1;
export const MAX_QUANTITY_TIMES_APPLIES = 10000;
